import { useEffect, useMemo } from 'react';

import { useDispatch } from 'src/services/redux';
import { useNotificationsMutation, userApi } from '../api';

export const useUnreadNotifications = () => {
  const [fetchNotifications, { data, isLoading }] = useNotificationsMutation();

  const notifications = useMemo(() => data?.items || [], [data]);

  const dispatch = useDispatch();

  useEffect(() => {
    fetchNotifications({ limit: 100 }).then(() => {
      dispatch(
        userApi.util.updateQueryData(
          'notificationsUnreadCount',
          undefined,
          () => 0,
        ),
      );
    });
  }, []);

  return { isLoading, notifications };
};
